// @ts-check
import angular from "angular";
import shiftTile from "./shift-tile.html";
import "./shift-tile.css";

export default angular
  .module("shiftTileComponent", [])
  .component("shiftTile", {
    template: shiftTile,
    controller: function() {},
    bindings: {
      rating: "=",
    },
    controllerAs: "$ctrl",
  });